// extracted by mini-css-extract-plugin
module.exports = {"message":"_40dbb53"};